import React from "react";
import ActionsContextV2 from "../ActionsContextV2";

import {
  Divider,
  Button,
  Dialog
} from "@material-ui/core";
import styled from "styled-components";

const TitleContainer = styled.div`
width:100%;
color: white;
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
padding:20px;
height:50px;
background-color:RGB(48, 74, 87);
display:flex;
align-items:center;
`

const ContentContainer = styled.div`
  padding-left:20px;
  // padding-right:20px;
  overflow-y:auto;

`

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:45px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:90px;
margin-left:20px;
`

const Title = styled.div`

`;

const Container = styled.div`

width:585px;
display:flex;
flex-direction:column;
align-items:space-between;
 
`;

const Subheader = styled.div`
height:50px;
display:flex;
background-color:#ECF5F9;
padding-left:20px;
padding-right:20px;
align-items:center;
justify-content:space-between;
font-family: Roboto;
font-size: 14px;
// font-weight: 500;
margin-left:-20px;
margin-right:0px;
`

const ConfirmMessage = styled.div`
  font-family: Roboto;
  font-size: 17px;
  font-weight: 500;
  padding-top: 20px;
`

class ActionChangeComplianceConfirmDialogV2 extends React.Component {
  static contextType = ActionsContextV2;

  constructor(props) {

    super(props);

    const changeComplianceAction = props.context.changeComplianceAction ? props.context.changeComplianceAction : {};

    const {
      deviationReasoning,
      deviationComments,
      modifiedProcedureSdn,
      modifiedProcedureTitle,
      modifiedProcedureUrl,
      isDeviating = true,

    } = changeComplianceAction;

    this.state = {
      deviationReasoning: (deviationReasoning === null) ? '' : deviationReasoning,
      deviationComments: (deviationComments === null) ? '' : deviationComments,
      modifiedProcedureSdn: (modifiedProcedureSdn === null) ? '' : modifiedProcedureSdn,
      modifiedProcedureTitle: (modifiedProcedureTitle === null) ? '' : modifiedProcedureTitle,
      modifiedProcedureUrl: (modifiedProcedureUrl === null) ? '' : modifiedProcedureUrl,
      isDeviating: !deviationComments ? true : isDeviating,
      newApplicabilityOption: props.context.actionsRedux.applicabilityOptionsObject['NA'],
      newApplicabilityId: 'NA'

    }

  }

  renderButtons() {
    const enableSave = true;
    // const enableSave = ((this.state.newApplicabilityOption && this.state.newApplicabilityOption.requiresDeviationReasoning && !this.state.isDeviating && this.state.deviationComments) ||
    //   (this.state.newApplicabilityOption && this.state.newApplicabilityOption.requiresDeviationReasoning && this.state.isDeviating && this.state.deviationReasoning && this.state.modifiedProcedureSdn && this.state.modifiedProcedureTitle && this.state.modifiedProcedureUrl)
    //   || (this.state.newApplicabilityOption && !this.state.newApplicabilityOption.requiresDeviationReasoning)) && this.state.newApplicabilityOption.value !== this.context.changeComplianceAction.applicabilityId;


    return (
      <ButtonsContainer>
        <ButtonContainer>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {

              this.context.closeChangeComplianceDialog();
            }}
          >
            Cancel
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          <Button
            fullWidth
            style={{ paddingLeft: 10 }}
            variant="contained"
            color="primary"
            disabled={!enableSave}
            onClick={() => {


              if (this.state.isDeviating) {
                this.context.uploadPendingDeviationFiles();
              }

              this.context.changeCompliance({
                ...this.context.changeComplianceAction,
                deviationReasoning: this.state.deviationReasoning,
                deviationComments: this.state.deviationComments,
                modifiedProcedureSdn: this.state.modifiedProcedureSdn,
                modifiedProcedureTitle: this.state.modifiedProcedureTitle,
                modifiedProcedureUrl: this.state.modifiedProcedureUrl,
                isDeviating: false, //this.state.isDeviating,
                deviationInProgress: this.state.deviationInProgress,
                applicabilityId: null, //this.state.newApplicabilityId

              });

              this.context.closeChangeComplianceDialog();


            }}
          >Confirm</Button>
        </ButtonContainer>
      </ButtonsContainer>

    )
  }

  render() {

    const renderDeviation = this.state.newApplicabilityOption && this.state.newApplicabilityOption.requiresDeviationReasoning;
    return (
      <>
        {this.context.changeComplianceDialogOpen &&
          <Dialog maxWidth='xl' open={true}>
            <Container >


              <TitleContainer><Title>Restart Procedure in workflow</Title></TitleContainer>


              <ContentContainer style={{ height: renderDeviation ? window.innerHeight - 300 : 140 }}>

                <Subheader>{`Procedure: ${this.context.changeComplianceAction.procedureSdn} - ${this.context.changeComplianceAction.procedureName}`} </Subheader>
                <ConfirmMessage>Are you sure you want to restart procedure in workflow?</ConfirmMessage>
              </ContentContainer>



            </Container>
            <Divider />
            {this.renderButtons()}
          </Dialog>
        }
      </>
    );
  }
}

export default ActionChangeComplianceConfirmDialogV2;
